import React, { useState } from "react";
import ConfirmPopup from "../../../ConfirmPopup/ConfirmPopup";

const ExportButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="sv-action-btn sv-btn-export" onClick={() => setOpen(true)}>
        <span className="sv-btn-text">Export</span>
      </button>

      <ConfirmPopup
        blur
        isOpen={open}
        title="Export Statement"
        message={
          <div style={{ textAlign: "center" }}>
      
            <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "6px" }}>1 supplier statement</div>
            <div style={{ color: "#555", fontSize: "13px", lineHeight: "1.6" }}>
              Are you sure you want to export this statement?
            </div>
          </div>
        }
        confirmLabel="Export"
        cancelLabel="Cancel"
        confirmColor="var(--color-brand)"
        onConfirm={() => setOpen(false)}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export default ExportButton;
